<template>
  <b-container fluid>
    <b-card
      v-if="config"
      no-body>
      <b-tabs
        card
        pills
        vertical
        nav-wrapper-class="w-25">
        <b-tab
          v-for="(_, device) in config"
          :key="device"
          :title="`${device}`"
          title-item-class="text-capitalize"
          @click.prevent="setActiveDevice">
          <paywall-form
            ref="menuform"
            :placeholder="placeholder"
            :config="config"
            :device="device" />
        </b-tab>
        <template #tabs-end>
          <b-button
            class="mt-5"
            variant="success"
            @click="$bvModal.show(modalID)">
            Add Device
          </b-button>

          <b-button
            class="mt-2 text-capitalize"
            variant="danger"
            @click="toggleOverlay">
            Delete {{ activeDevice }}
          </b-button>
        </template>
      </b-tabs>

      <b-modal
        :id="modalID"
        hide-footer
        title="Add New Device"
        @hidden="resetModal">
        <b-form-group>
          <b-input-group
            id="input-group-new-device"
            prepend="Name">
            <b-form-input
              id="input-new-device"
              v-model="newDeviceName"
              debounce="500"
              :state="validate()"
              placeholder="Enter device name" />
            <b-form-invalid-feedback class="text-capitalize">
              {{ errorMsg }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <div
          class="mt-3 w-50">
          <b-button
            class="mr-3"
            variant="danger"
            @click="$bvModal.hide(modalID)">
            Cancel
          </b-button>
          <b-button
            :disabled="disableConfirm"
            variant="success"
            @click="addDevice">
            Confirm
          </b-button>
        </div>
      </b-modal>
    </b-card>

    <paywall-overlay
      :show="showOverlay"
      :msg="overlayMsg"
      @onConfirm="onConfirm"
      @onCancel="toggleOverlay" />
  </b-container>
</template>

<script>
import PaywallForm from "@/components/Paywall/PaywallForm"
import {mapGetters} from "vuex"
import PaywallOverlay from "@/components/Paywall/PaywallOverlay"

export default {
  name: "PaywallMenu",
  components: {
    PaywallOverlay,
    PaywallForm,
  },
  props: {
    config: {
      type: Object,
      default: null,
      required: true,
    },

  },
  data() {
    return {
      showOverlay: false,
      activeDevice: "samsung",
      newDeviceName: "",
      errorMsg: "* required",
      disableConfirm: true,
    }
  },
  computed: {
    ...mapGetters(['canPaywallEdit']),
    modalID: () => "add-new-device-modal",
    overlayMsg() {
      return `delete ${this.activeDevice}'s config?`
    },
    placeholder() {
      return {
        header: "Subscribe to MLB.TV",
        subheader: `Visit MLB.com/${this.newDeviceName} to purchase`,
        packages: [
          {
            enabled: true,
            price: "Free",
            text: "Watch the MLB.TV Free MLB Game of the Day.",
            title: "MLB Account",
            type: "free",
            purchaseLink: `mlb.com/${this.newDeviceName}`,
            buttons: [
              {
                text: "button one",
                enabled: true,
              },
              {
                text: "button two",
                enabled: false,
              },
            ],
          },
        ],
        rules: {
          header: {
            charMax: 200,
          },
          subheader: {
            charMax: 200,
          },
          title: {
            charMax: 200,
          },
          price: {
            charMax: 200,
          },
          text: {
            charMax: 200,
          },
          purchaseLink: {
            charMax: 200,
          },
        },
      }
    },
  },
  methods: {
    setActiveDevice({target}) {
      this.activeDevice = target.innerText.toLowerCase()
    },
    onConfirm() {
      this.$delete(this.config, this.activeDevice)
      this.toggleOverlay()

      const devices = Object.keys(this.config)
      this.activeDevice = devices[devices.length - 1]
    },
    toggleOverlay() {
      this.showOverlay = !this.showOverlay
    },
    resetModal() {
      this.newDeviceName = ""
      this.errorMsg = "* required"
    },
    addDevice() {
      if (this.newDeviceName.length > 0) {
        this.$set(this.config, this.newDeviceName.toLowerCase(), this.placeholder)
        this.$bvModal.hide(this.modalID)
      }
    },
    isValid() {
      let allValid = true
      const {menuform} = this.$refs

      Object.keys(menuform).forEach(key => {
        if (!menuform[key].isValid()) allValid = false
      })
      return allValid
    },
    validate() {
      if (this.newDeviceName.length > 0) {
        const deviceExists = Object.keys(this.config).includes(this.newDeviceName.toLowerCase())

        if (deviceExists) {
          this.errorMsg = `* the device ${this.newDeviceName} already has a published config`
          this.disableConfirm = true
          return false
        } else {
          this.disableConfirm = false
          return true
        }
      }
      return null
    },
  },
}
</script>

<style scoped></style>
